import React from "react";

export default function NotificationIcon({ color = "currentColor" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 10C17.3453 10 17.6804 9.95625 18 9.87398V15L20 17V18H4V17L6 15V9C6.10066 7.81157 6.59337 6.69028 7.40068 5.81237C8.208 4.93446 9.28415 4.3497 10.46 4.15C10.4 3.46 10.47 2 12 2C13.4088 2 13.5797 3.23777 13.5512 3.97256C13.2009 4.56707 13 5.26007 13 6C13 8.20914 14.7909 10 17 10ZM12 21.5C12.7956 21.5 13.5587 21.1839 14.1213 20.6213C14.6839 20.0587 15 19.2956 15 18.5H9C9 19.2956 9.31607 20.0587 9.87868 20.6213C10.4413 21.1839 11.2044 21.5 12 21.5Z"
        fill="#17171B"
      />
      <circle
        cx="17"
        cy="6"
        r="3.5"
        fill={!!color ? color : "#252E3B"}
      />
    </svg>
  );
}
